export const activitiesActions = {
    SET_ACTIVITIES: 'SET_ACTIVITIES',
    GET_ACTIVITIES: 'GET_ACTIVITIES',
    GET_ACTIVITIES_FAILED: 'GET_ACTIVITIES_FAILED',
    GET_ACTIVITIES_FOR_PROJECT: 'GET_ACTIVITIES_GROUPS_FOR_PROJECT',
    GET_ALL_ACTIVITIES: 'GET_ALL_ACTIVITIES',
    GET_ALL_ACTIVITIES_FOR_PROJECT: 'GET_ALL_ACTIVITIES_FOR_PROJECT',
    GET_ACTIVITIES_BY_TYPE: 'GET_ACTIVITIES_BY_TYPE',
    SET_ACTIVITIES_BY_TYPE: 'SET_ACTIVITIES_BY_TYPE',
    RESET_ACTIVITIES_DATA:'RESET_ACTIVITIES_DATA'
};

const activitiesState = {};

export const activitiesReducer = (state = activitiesState, action: any) => {
    switch (action.type) {
        case activitiesActions.GET_ACTIVITIES:
        case activitiesActions.SET_ACTIVITIES:
            return Object.assign({}, state, action.payload);

        case activitiesActions.RESET_ACTIVITIES_DATA:
            return Object.assign({}, state, { activitiesData: null });

        default:
            return state;
    }
};

const activitiesByTypeState = {};

export const activitiesByTypeReducer = (state = activitiesByTypeState, action: any) => {
    switch (action.type) {
        case activitiesActions.GET_ACTIVITIES_BY_TYPE:
        case activitiesActions.SET_ACTIVITIES_BY_TYPE:
            return Object.assign({}, state, action.payload);

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/activitiesReducer.ts